import { Component, EventEmitter, Output } from '@angular/core';
import { SitePage } from '../../project-data';

@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
})
export class SiteHeaderComponent {
  @Output() readonly inquiryRequested = new EventEmitter<void>();
  @Output() readonly pageSelected = new EventEmitter<SitePage>();

  protected showHome(event: Event): void {
    event.preventDefault();
    this.pageSelected.emit('home');
  }
}
